module.exports = __webpack_public_path__ + "static/media/pass_success.7f63ac7b.svg";